export function escapeHtml(str){
  const d = document.createElement('div');
  d.textContent = str==null ? '' : String(str);
  return d.innerHTML;
}
